export const options = [
  {
    value: 'all',
    label: 'All items'
  },
  {
    value: 'withLot',
    label: 'Items that need feedback only'
  }
];
